//前端结算申请 -- 普通结算
import {rule} from '@/util/validateRules'
import {
	applySettleDicData,
	cancelStatusDicData,
	changeCodeDicData,
	feeRateDicData,
	fontApplySettleDicData,
} from '@/const/crud/settlement/product'
import {getHasFeeRateBySettleByRate} from '@/util/settleUtils'
import {getInsureTypesString} from '@/util/insureTypesUtils'
import store from '@/store'

export const fontApplyBasicOption = (safe) => {
	//safe => vue的this 对象
	return {
		card: true,
		stripe: true,
		border: true,
		align: 'center',
		selection: true,
		addBtn: false,
		searchLabelWidth: 120,
		excelBtn: true,
		selectClearBtn: false,
		delBtn: false,
		editBtn: false,
		menu: false,
		selectable: (row, index) => {
			//true，可以点击
			return row.payMoney > 0
		},
		column: [
			{
				label: '渠道名称',
				prop: 'channelName',
			},
			{
				label: '操作人',
				prop: 'distAccountName',
				formatter: ({distAccountName = ''}) => {
					return distAccountName ? distAccountName : '--'
				},
			},
			{
				label: '被保企业/个人',
				prop: 'unitName',
				width: 150,
				search: true,
				fixed: true,
				searchOrder: 1,
			},
			{
				label: '保单号',
				prop: 'policyNo',
				search: true,
				width: 200,
				searchOrder: 3,
				fixed: true,
			},
			{
				label: '批单号',
				prop: 'endorseNo',
				search: true,
				width: 200,
				searchOrder: 4,
				fixed: true,
			},
			{
				label: '险种名称',
				prop: 'insureType',
				dicData: getInsureTypesString(),
				type: 'select',
				search: true,
				width: 150,
				searchOrder: 2,
			},
			{
				label: '业务类型',
				prop: 'changeCode',
				dicData: changeCodeDicData,
				search: true,
				width: 100,
				type: 'select',
				searchOrder: 5,
			},
			{
				label: '档次',
				prop: 'feeRate',
				dicData: feeRateDicData,
				hide: true,
			},
			{
				label: '保费金额(元)',
				prop: 'payMoney',
			},
			{
				label: '可结算保费金额(元)',
				prop: 'settleMoney',
			},
			{
				label: '基础费用率',
				prop: 'basicFeeRate',
			},
			{
				label: '基础费用(元)',
				prop: 'basicFee',
			},
			{
				label: '附加费用率',
				prop: 'additionalFeeRate',
			},
			{
				label: '附加费用(元)',
				prop: 'additionalFee',
			},
			{
				label: '预计结算费用(元)',
				prop: 'allFeePre',
			},
			{
				label: '结算费用(元)',
				prop: 'allFee',
				hide: true,
			},
			// {
			//     label: '结算状态',
			//     prop: 'settleStatus',
			//     dicData: settleStatusDicData,
			//     fixed: 'right',
			//     hide: false
			// },
			{
				label: '投保时间',
				prop: 'createTime',
				width: 160,
			},
			{
				label: '支付时间',
				prop: 'payTime',
				search: true,
				type: 'date',
				searchRange: true,
				searchOrder: 99,
				searchSpan: 12,
				width: 160,
				valueFormat: 'yyyy-MM-dd HH:mm:ss',
				format: 'yyyy-MM-dd HH:mm:ss',
				defaultTime: ['00:00:00', '23:59:59'],
				startPlaceholder: '选择开始时间',
				endPlaceholder: '选择结束时间',
				rangeSeparator: '至',
			},
			{
				label: '生效时间',
				prop: 'effectiveDate',
				width: 160,
			},
			{
				label: '到期时间',
				prop: 'expiryDate',
				width: 160,
			},
			{
				label: '备注',
				prop: 'remark',
				type: 'textarea',
				formatter: ({applyItemDTO = {}}) => {
					if (!safe.validatenull(applyItemDTO)) {
						let {feeRemark = '--'} = applyItemDTO
						return feeRemark
					}
					return '--'
				},
				width: 160,
			},
		],
	}
}

//前端结算申请-活动奖励结算
export const fontApplyAwardOption = (safe) => {
	return {
		card: true,
		stripe: true,
		border: true,
		align: 'center',
		menuAlign: 'center',
		searchMenuSpan: 8,
		selection: true,
		addBtn: false,
		excelBtn: true,
		menu: false,
		column: [
			{
				label: '奖励规则',
				prop: 'name',
				formatter: ({ruleAward: {name = '--'} = {}, ruleType, coupon: {name: couponName = ''} = {}}) => {
					return ruleType === 'COUPON' ? couponName : name
				},
			},
			{
				label: '险种名称',
				prop: 'insureTypes',
				dicData: getInsureTypesString(),
				type: 'select',
				multiple: true,
				dataType: 'string',
				search: true,
				width: 150,
				searchOrder: 2,
			},
			{
				label: '奖励类型',
				prop: 'ruleType',
				dicData: [
					{
						label: '佣金券',
						value: 'COUPON',
					},
					{
						label: '返现',
						value: 'AWARD',
					},
				],
				type: 'select',
				search: true,
				width: 150,
				searchOrder: 2,
			},
			{
				label: '达标档次',
				prop: 'feeRatePercent',
				formatter: ({ruleAward: {feeRatePercent = ''} = {}, insureTypes = 0}) => {
					if (!feeRatePercent) {
						return '--'
					}
					return getHasFeeRateBySettleByRate(feeRatePercent, insureTypes)
				},
			},
			{
				label: '奖励档次',
				prop: 'countRatePercent',
				formatter: ({ruleAward: {countRatePercent = 0} = {}, insureTypes = 0}) => {
					if (!countRatePercent) {
						return '--'
					}
					return getHasFeeRateBySettleByRate(countRatePercent, insureTypes)
				},
			},

			{
				label: '保费金额(元)',
				prop: 'payMoney',
			},
			{
				label: '奖励费用率',
				prop: 'feeRate',
			},
			{
				label: '预计结算费用(元)',
				prop: 'feePre',
			},
			{
				label: '实际结算费用(元)',
				prop: 'fee',
				hide: true,
			},
			{
				label: '奖励是否兼得',
				prop: 'awardCombine',
				formatter: ({awardCombine = '--'}) => awardCombine,
			},
			{
				label: '统计类型',
				prop: 'countType',
				formatter: ({countType = '--'}) => countType,
			},
			{
				label: '开始时间',
				prop: 'countStartTime',
			},
			{
				label: '结束时间',
				prop: 'countEndTime',
			},
			// , {
			//     label: '备注',
			//     prop: 'remark',
			//     type: 'textarea',
			//     maxlength: 100,
			//     showWordLimit: true,
			//     span: 24,
			//     minRows: 3,
			//     maxRows: 5
			// }
		],
	}
}

//前端结算申请详情
export const frontApplyDetailOption = (safe) => {
	return {
		card: true,
		stripe: true,
		border: true,
		align: 'center',
		menu: false,
		excelBtn: true,
		addBtn: false,
		column: [
			{
				label: '出单渠道',
				prop: '',
			},
			{
				label: '险种名称',
				prop: '',
				search: true,
				searchOrder: 1,
			},
			{
				label: '投保时间',
				prop: '',
			},
			{
				label: '保单号',
				prop: '',
				search: true,
				searchOrder: 2,
			},
			{
				label: '批单号',
				prop: '',
				search: true,
				searchOrder: 3,
			},
			{
				label: '业务类型',
				prop: '',
				searchOrder: 4,
			},
			{
				label: '保费金额',
				prop: '',
				formatter: ({payMoney}) => {
					return payMoney / 100
				},
			},
			{
				label: '投保人员',
				prop: '',
			},
			{
				label: '操作人',
				prop: '',
				searchOrder: 5,
			},
			{
				label: '费用率',
				prop: '',
			},
			{
				label: '单笔费用',
				prop: '',
			},
			{
				label: '生效时间',
				prop: '',
			},
			{
				label: '到期时间',
				prop: '',
			},
			{
				label: '保单状态',
				prop: '',
				search: true,
				searchOrder: 6,
			},
			{
				label: '档次',
				prop: '',
			},
			{
				label: '结算状态',
				prop: '',
			},
		],
	}
}

//前端结算管理
export const frontApplyIndexBasicOption = (safe) => {
	return {
		card: true,
		stripe: true,
		border: true,
		align: 'center',
		menuAlign: 'center',
		menuWidth: 180,
		searchLabelWidth: 120,
		editBtn: false,
		delBtn: false,
		addBtn: false,
		column: [
			{
				label: '结算编号',
				prop: 'no',
				width: 140,
			},
			{
				label: '申请时间',
				prop: 'createdAt',
				type: 'date',
				searchSpan: 12,
				search: true,
				searchRange: true,
				width: 160,
				valueFormat: 'yyyy-MM-dd HH:mm:ss',
				format: 'yyyy-MM-dd HH:mm:ss',
				defaultTime: ['00:00:00', '23:59:59'],
				startPlaceholder: '选择开始时间',
				endPlaceholder: '选择结束时间',
				rangeSeparator: '至',
			},
			{
				label: '当前状态',
				prop: 'userStatus',
				type: 'select',
				width: 120,
				dicData: fontApplySettleDicData,
				search: true,
				searchOrder: 99,
			},
			{
				label: '预计结算费用(元)',
				prop: 'feePre',
				width: 140,
			},
			{
				label: '实际结算费用(元)',
				prop: 'fee',
				width: 140,
			},
			{
				label: '预计含税结算费用(元)',
				prop: 'feePreTax',
				width: 160,
			},
			{
				label: '实际含税结算费用(元)',
				prop: 'feeTax',
				width: 160,
			},
			{
				label: '是否含税',
				prop: 'settleTaxFlag',
				dicData: [
					{
						label: '是',
						value: '1',
					},
					{
						label: '否',
						value: '0',
					},
				],
				type: 'select',
				search: true,
			},
			{
				label: '开启时间',
				prop: 'startDate',
			},
			{
				label: '结束时间',
				prop: 'endDate',
			},
			{
				label: '更新时间',
				prop: 'updatedAt',
			},
			{
				label: '汇款时间',
				prop: 'remitAt',
				formatter: ({remitAt = ''}) => {
					return remitAt ? remitAt.split(' ')[0] : '--'
				},
			},
			{
				label: '审核说明',
				prop: 'desc',
				overHidden: true,
			},
		],
	}
}

//前端结算管理
export const frontApplyIndexAwardOption = (safe) => {
	return {
		card: true,
		stripe: true,
		border: true,
		align: 'center',
		menuAlign: 'center',
		menuWidth: 180,
		selection: true,
		searchLabelWidth: 120,
		selectionWidth: 100,
		reserveSelection: true,
		searchMenuSpan: 12,
		editBtn: false,
		delBtn: false,
		addBtn: false,
		column: [
			{
				label: '结算编号',
				prop: 'no',
				width: 140,
			},
			{
				label: '申请时间',
				prop: 'createdAt',
				type: 'date',
				searchSpan: 12,
				search: true,
				searchRange: true,
				width: 160,
				valueFormat: 'yyyy-MM-dd HH:mm:ss',
				format: 'yyyy-MM-dd HH:mm:ss',
				defaultTime: ['00:00:00', '23:59:59'],
				startPlaceholder: '选择开始时间',
				endPlaceholder: '选择结束时间',
				rangeSeparator: '至',
			},
			{
				label: '当前状态',
				prop: 'userStatus',
				type: 'select',
				width: 120,
				dicData: fontApplySettleDicData,
				search: true,
				searchOrder: 99,
			},
			{
				label: '预计结算费用(元)',
				prop: 'feePre',
				width: 140,
			},
			{
				label: '实际结算费用(元)',
				prop: 'fee',
				width: 140,
			},
			{
				label: '预计含税结算费用(元)',
				prop: 'feePreTax',
				width: 160,
			},
			{
				label: '实际含税结算费用(元)',
				prop: 'feeTax',
				width: 160,
			},
			{
				label: '是否含税',
				prop: 'settleTaxFlag',
				dicData: [
					{
						label: '是',
						value: '1',
					},
					{
						label: '否',
						value: '0',
					},
				],
				type: 'select',
				search: true,
			},
			{
				label: '汇款时间',
				prop: 'remitAt',
				formatter: ({remitAt = ''}) => {
					return remitAt ? remitAt.split(' ')[0] : '--'
				},
			},
			{
				label: '审核说明',
				prop: 'desc',
				overHidden: true,
			},
		],
	}
}

///-----------------------后端option---------------------------//
//后端结算申请检索 ---普通结算
export const afterApplyListBasicOption = (safe) => {
	return {
		card: true,
		stripe: true,
		border: true,
		align: 'center',
		menuAlign: 'center',
		delBtn: false,
		editBtn: false,
		excelBtn: false,
		menuWidth: 100,
		searchMenuSpan: 12,
		selection: true,
		addBtn: false,
		searchLabelWidth: 120,
		selectionWidth: 100,
		reserveSelection: true,
		column: [
			{
				label: '渠道名称',
				prop: 'channelId',
				search: true,
				searchOrder: 80,
				hide: true,
				display: false,
				// ,
				// type: 'select',
				// props: {
				//   label: 'name',
				//   value: 'id'
				// },
				// searchOrder: 1,
				// searchFilterable: true,
				//
				// dicUrl: '/dist/distChannel/list?parentId=0'
			},
			{
				label: '结算编号',
				prop: 'no',
				search: true,
				searchOrder: 65,
				width: 120,
			},
			{
				label: '渠道名称',
				prop: 'channelName',
			},
			{
				label: '申请时间',
				prop: 'createdAt',
				type: 'date',
				width: 160,
				searchOrder: 100,
				searchSpan: 12,
				searchRange: true,
				search: true,
				valueFormat: 'yyyy-MM-dd HH:mm:ss',
				format: 'yyyy-MM-dd HH:mm:ss',
				defaultTime: ['00:00:00', '23:59:59'],
				startPlaceholder: '选择开始时间',
				endPlaceholder: '选择结束时间',
				rangeSeparator: '至',
			},
			{
				label: '预计结算费用(元)',
				prop: 'feePre',
			},
			{
				label: '实际结算费用(元)',
				prop: 'fee',
			},
			{
				label: '预计含税结算费用(元)',
				prop: 'feePreTax',
			},
			{
				label: '实际含税结算费用(元)',
				prop: 'feeTax',
			},
			{
				label: '当期结算状态',
				prop: 'allFlag',
				searchOrder: 90,
				value: 0,
				width: 110,
				dicData: [
					{
						label: '已结清',
						value: 1,
					},
					{
						label: '未结清',
						value: 0,
					},
				],
				search: true,
				type: 'select',
			},
			{
				//对公数据
				label: '是否含税',
				prop: 'settleTaxFlag',
				searchOrder: 85,
				type: 'select',
				dicData: [
					{
						label: '是',
						value: '1',
					},
					{
						label: '否',
						value: '0',
					},
				],
				search: true,
			},
			{
				//CREATED待处理，CANCELED已撤销，REJECTED_FIRST初审驳回，
				// APPROVED_FIRST上级复审，REJECTED_FINAL复审驳回，
				// APPROVED_FINAL复审通过，COMMITTED_FINANCE提交财务处理，REMITTED已打款
				label: '状态',
				prop: 'status',
				type: 'select',
				search: true,
				dicData: applySettleDicData,
				searchOrder: 75,
			},
			{
				label: '是否异常',
				prop: 'errorStatus',
				type: 'select',
				hide: true,
				display: true,
				search: true,
				searchOrder: 70,
				value: '',
				dicData: [
					{
						label: '正常',
						value: '0',
					},
					{
						label: '申请中的保单出现退保',
						value: '1',
					},
					{
						label: '申请外的保单出现退保',
						value: '2',
					},
					{
						label: '同时出现退保',
						value: '3',
					},
				],
			},
			{
				label: '开始时间',
				prop: 'startDate',
				type: 'datetime',
			},
			{
				label: '结束时间',
				prop: 'endDate',
				type: 'datetime',
			},
			{
				label: '汇款时间',
				prop: 'remitAt',
				formatter: ({remitAt = ''}) => {
					return remitAt ? remitAt.split(' ')[0] : '--'
				},
				type: 'datetime',
			},
			{
				label: '审核说明',
				prop: 'desc',
				width: 120,
				//超出隐藏
				overHidden: true,
				slot: true,
			},
		],
	}
}

//后端结算申请检索 ---奖励结算
export const afterApplyListAwardOption = (safe) => {
	return {
		card: true,
		stripe: true,
		border: true,
		align: 'center',
		menuAlign: 'center',
		menuWidth: 100,
		delBtn: false,
		editBtn: false,
		excelBtn: false,
		searchMenuSpan: 6,
		selection: true,
		addBtn: false,
		searchLabelWidth: 120,
		selectionWidth: 100,
		reserveSelection: true,
		column: [
			{
				label: '渠道名称',
				prop: 'channelId',
				search: true,
				type: 'select',
				props: {
					label: 'name',
					value: 'id',
				},
				searchOrder: 1,
				searchFilterable: true,
				formatter: ({channelName}) => {
					return channelName
				},
			},
			{
				label: '结算编号',
				prop: 'no',
				search: true,
				searchOrder: 1,
				fixed: true,
				width: 120,
			},
			{
				label: '申请时间',
				prop: 'createdAt',
				type: 'date',
				width: 160,
				searchOrder: 5,
				searchSpan: 12,
				searchRange: true,
				search: true,
				valueFormat: 'yyyy-MM-dd HH:mm:ss',
				format: 'yyyy-MM-dd HH:mm:ss',
				defaultTime: ['00:00:00', '23:59:59'],
				startPlaceholder: '选择开始时间',
				endPlaceholder: '选择结束时间',
				rangeSeparator: '至',
			},
			{
				label: '预计结算费用(元)',
				prop: 'feePre',
			},
			{
				label: '实际结算费用(元)',
				prop: 'fee',
			},
			{
				label: '预计含税结算费用(元)',
				prop: 'feePreTax',
			},
			{
				label: '实际含税结算费用(元)',
				prop: 'feeTax',
			},
			{
				//对公数据
				label: '是否含税',
				prop: 'settleTaxFlag',
				type: 'select',
				dicData: [
					{
						label: '是',
						value: '1',
					},
					{
						label: '否',
						value: '0',
					},
				],
				search: true,
			},
			{
				//CREATED待处理，CANCELED已撤销，REJECTED_FIRST初审驳回，
				// APPROVED_FIRST上级复审，REJECTED_FINAL复审驳回，
				// APPROVED_FINAL复审通过，COMMITTED_FINANCE提交财务处理，REMITTED已打款
				label: '状态',
				prop: 'status',
				type: 'select',
				search: true,
				dicData: applySettleDicData,
				searchOrder: 3,
			},
			{
				label: '汇款时间',
				prop: 'remitAt',
				type: 'datetime',
				formatter: ({remitAt = ''}) => {
					return remitAt ? remitAt.split(' ')[0] : '--'
				},
			},
			{
				label: '审核说明',
				prop: 'desc',
				overHidden: true,
				slot: true,
			},
		],
	}
}

//后端单渠道结算详情
export const afterApplyDetailBasicOption = (safe) => {
	//safe => vue的this 对象
	return {
		card: true,
		stripe: true,
		border: true,
		align: 'center',
		addBtn: false,
		gutter: 40,
		searchMenuSpan: 7,
		excelBtn: true,
		delBtn: false,
		editBtn: false,
		menuWidth: 160,
		searchLabelWidth: 120,
		column: [
			{
				label: '被保企业/个人',
				prop: 'unitName',
				width: 150,
				search: true,
				fixed: true,
				searchOrder: 1,
			},
			{
				label: '保单号',
				prop: 'policyNo',
				search: true,
				width: 200,
				searchOrder: 3,
				fixed: true,
			},
			{
				label: '主渠道名称',
				prop: 'mainChannelName',
				width: 110,
				// search: true,
				// type: 'select',
				// props: {
				//     label: 'name',
				//     value: 'id'
				// },
				// searchOrder: 1,
				// searchFilterable: true,
				// dicUrl: '/dist/distChannel/list?parentId=0'
			},
			{
				label: '渠道名称',
				prop: 'channelName',
				width: 110,
				// search: true,
				// type: 'select',
				// props: {
				//     label: 'name',
				//     value: 'id'
				// },
				// searchOrder: 1,
				// searchFilterable: true,
				// dicUrl: '/dist/distChannel/list?parentId=0'
			},
			{
				label: '批单号',
				prop: 'endorseNo',
				search: true,
				width: 200,
				searchOrder: 4,
				fixed: true,
			},
			{
				label: '险种名称',
				prop: 'insureType',
				dicData: getInsureTypesString(),
				type: 'select',
				search: true,
				width: 150,
				searchOrder: 2,
				slot: true,
			},
			{
				label: '业务类型',
				prop: 'changeCode',
				dicData: changeCodeDicData,
				search: true,
				type: 'select',
				searchOrder: 5,
			},
			{
				label: '档次',
				prop: 'feeRate',
				dicData: feeRateDicData,
				// formatter: ({feeRate,insureType}) => {
				//     return  insureType === 8 ? feeRate : ''
				// }
			},
			{
				label: '保费金额(元)',
				prop: 'payMoney',
			},
			{
				label: '可结算保费金额(元)',
				prop: 'settleMoney',
			},
			{
				label: '基础费用率',
				prop: 'basicFeeRate',
			},
			{
				label: '基础费用(元)',
				prop: 'basicFee',
			},
			{
				label: '附加费用率',
				prop: 'additionalFeeRate',
			},
			{
				label: '附加费用(元)',
				prop: 'additionalFee',
			},
			{
				label: '预计结算费用(元)',
				prop: 'allFeePre',
			},
			{
				label: '调整后结算费用(元)',
				prop: 'allFee',
			},
			// {
			//     label: '结算状态',
			//     prop: 'settleStatus',
			//     dicData: settleStatusDicData,
			//     fixed: 'right',
			//     hide: false,
			//     width: 100
			// },
			{
				label: '投保时间',
				prop: 'createTime',
				width: 160,
			},
			{
				label: '支付时间',
				prop: 'payTime',
				search: true,
				type: 'date',
				searchRange: true,
				searchOrder: 99,
				searchSpan: 9,
				width: 160,
				valueFormat: 'yyyy-MM-dd',
			},
			{
				label: '生效时间',
				prop: 'effectiveDate',
				width: 160,
			},
			{
				label: '到期时间',
				prop: 'expiryDate',
				width: 160,
			},
			{
				label: '备注',
				prop: 'remark',
				type: 'textarea',
				formatter: ({applyItemDTO = {}}) => {
					if (!safe.validatenull(applyItemDTO)) {
						let {feeRemark = '--'} = applyItemDTO
						return feeRemark
					}
					return '--'
				},
				width: 160,
			},
		],
	}
}

//后端结算申请详情
export const afterApplyAwardOption = (safe) => {
	return {
		card: true,
		stripe: true,
		border: true,
		align: 'center',
		menuAlign: 'center',
		menuWidth: 100,
		searchMenuSpan: 8,
		delBtn: false,
		editBtn: false,
		addBtn: false,
		column: [
			{
				label: '奖励规则',
				prop: 'name',
				formatter: ({ruleAward = null, coupon = null}) => {
					return ruleAward ? ruleAward.name : coupon ? coupon.name : '--'
				},
			},
			{
				label: '险种名称',
				prop: 'insureTypes',
				dicData: getInsureTypesString(),
				type: 'select',
				search: true,
				width: 150,
				searchOrder: 2,
				//多选 string 类型
				multiple: true,
				dataType: 'string',
			},
			{
				label: '达标档次',
				prop: 'feeRatePercent',
				formatter: ({ruleAward = {}, insureType = 0}) => {
					let {feeRatePercent = 0} = ruleAward
					return getHasFeeRateBySettleByRate(feeRatePercent, insureType)
				},
			},
			{
				label: '奖励档次',
				prop: 'countRatePercent',
				formatter: ({ruleAward = {}, insureType = 0}) => {
					let {countRatePercent = 0} = ruleAward
					return getHasFeeRateBySettleByRate(countRatePercent, insureType)
				},
			},

			{
				label: '保费金额(元)',
				prop: 'payMoney',
			},
			{
				label: '奖励费用率',
				prop: 'feeRate',
			},
			{
				label: '预计结算费用(元)',
				prop: 'allFeePre',
			},
			{
				label: '调整后结算费用(元)',
				prop: 'allFee',
			},
			{
				label: '奖励是否兼得',
				prop: 'awardCombine',
			},
			{
				label: '统计类型',
				prop: 'countType',
			},
			// {
			//     label: '结算状态',
			//     prop: 'settleStatus',
			//     select: true
			// },
			{
				label: '开始时间',
				prop: 'countStartTime',
			},
			{
				label: '结束时间',
				prop: 'countEndTime',
			},
			{
				label: '备注',
				prop: 'remark',
				type: 'textarea',
				formatter: ({applyItemDTO = {}}) => {
					if (!safe.validatenull(applyItemDTO)) {
						let {feeRemark = '--'} = applyItemDTO
						return feeRemark
					}
					return '--'
				},
				width: 160,
			},
		],
	}
}

//异常保单信息变更
export const changeFeeOption = (safe) => {
	return {
		card: true,
		stripe: true,
		border: true,
		editBtn: false,
		delBtn: false,
		align: 'center',
		menuAlign: 'center',
		menuWidth: 140,
		searchMenuSpan: 8,
		searchLabelWidth: 120,
		addBtn: false,
		excelBtn: true,
		column: [
			{
				label: '被保企业/个人',
				prop: 'unitName',
				width: 150,
				search: true,
				fixed: true,
				searchOrder: 1,
			},
			{
				label: '保单号',
				prop: 'policyNo',
				width: 200,
				search: true,
			},
			{
				label: '批单号',
				prop: 'endorseNo',
				width: 200,
				search: false,
				hide: true,
			},
			{
				label: '保险产品',
				prop: 'insureType',
				dicData: getInsureTypesString(),
				search: true,
				type: 'select',
			},
			{
				label: '主渠道名称',
				prop: 'distChannelId',
				search: true,
				type: 'select',
				hide: true,
				props: {
					label: 'name',
					value: 'id',
				},
				searchOrder: 1,
				searchFilterable: true,
				dicUrl: '/dist/distChannel/list?parentId=0',
			},
			{
				label: '主渠道名称',
				prop: 'mainChannelName',
				width: 110,
			},
			{
				label: '渠道名称',
				prop: 'channelName',
				width: 110,
			},
			{
				label: '业务类型',
				prop: 'changeCode',
				dicData: changeCodeDicData,
			},
			{
				label: '退保费用(元)',
				prop: 'payMoney',
			},
			{
				label: '预计试算扣回费用(元)',
				prop: 'feeCalc',
				width: 100,
			},
			{
				label: '核算扣回费用(元)',
				prop: 'feePre',
				width: 100,
			},
			{
				label: '退保时间',
				prop: 'createTime',
				width: 160,
			},
			{
				label: '支付时间',
				prop: 'payTime',
				width: 160,
			},
			{
				label: '档次',
				prop: 'feeRate',
				dicData: feeRateDicData,
				width: 80,
				hide: false,
			},
			{
				label: '状态',
				prop: 'cancelStatus',
				type: 'select',
				dicData: cancelStatusDicData,
				width: 80,
				hide: false,
				// search: true
			},
			{
				label: '备注',
				prop: 'remark',
			},
		],
	}
}

//未结算保单列表
export const noApplyOption = (safe) => {
	return {
		card: true,
		stripe: true,
		border: true,
		align: 'center',
		menu: false,
		editBtn: false,
		addBtn: false,
		excelBtn: true,
		menuWidth: 100,
		searchLabelWidth: 120,
		column: [
			{
				label: '被保企业/个人',
				prop: 'unitName',
				width: 150,
				fixed: true,
				search: true,
				searchOrder: 1,
			},
			{
				label: '保单号',
				prop: 'policyNo',
				search: true,
				width: 200,
				searchOrder: 3,
				fixed: true,
			},
			{
				label: '批单号',
				prop: 'endorseNo',
				search: true,
				width: 200,
				searchOrder: 4,
				fixed: true,
			},
			{
				label: '险种名称',
				prop: 'insureType',
				dicData: getInsureTypesString(),
				type: 'select',
				search: true,
				width: 150,
				searchOrder: 2,
			},
			{
				label: '主渠道名称',
				prop: 'distChannelId',
				search: true,
				type: 'select',
				hide: true,
				props: {
					label: 'name',
					value: 'id',
				},
				searchOrder: 1,
				searchFilterable: true,
				dicUrl: '/dist/distChannel/list?parentId=0',
			},
			{
				label: '主渠道名称',
				prop: 'mainChannelName',
				width: 110,
			},
			{
				label: '渠道名称',
				prop: 'channelName',
				width: 110,
			},
			{
				label: '业务类型',
				prop: 'changeCode',
				dicData: changeCodeDicData,
				search: true,
				width: 100,
				type: 'select',
				searchOrder: 5,
			},
			{
				label: '档次',
				prop: 'feeRate',
				dicData: feeRateDicData,
				hide: true,
			},
			{
				label: '保费金额(元)',
				prop: 'payMoney',
			},
			{
				label: '可结算保费金额(元)',
				prop: 'settleMoney',
				hide: false,
			},
			{
				label: '基础费用率',
				prop: 'basicFeeRate',
				hide: false,
			},
			{
				label: '基础费用(元)',
				prop: 'basicFee',
				hide: false,
			},
			{
				label: '附加费用率',
				prop: 'additionalFeeRate',
				hide: false,
			},
			{
				label: '附加费用(元)',
				prop: 'additionalFee',
				hide: false,
			},
			{
				label: '预计结算费用(元)',
				prop: 'allFeePre',
				hide: false,
			},
			{
				label: '结算费用(元)',
				prop: 'fee',
				hide: true,
			},
			{
				label: '投保时间',
				prop: 'createTime',
				width: 160,
			},
			{
				label: '支付时间',
				prop: 'payTime',
				search: true,
				type: 'date',
				searchRange: true,
				searchOrder: 99,
				searchSpan: 9,
				width: 160,
				valueFormat: 'yyyy-MM-dd',
			},
			{
				label: '生效时间',
				prop: 'effectiveDate',
				width: 160,
			},
			{
				label: '到期时间',
				prop: 'expiryDate',
				width: 160,
			},
		],
	}
}

export function diffInsuranceOptionFun() {
	let tempData = {
		border: true,
		stripe: true,
		menu: false,
		align: 'center',
		header: false,
		column: [
			{
				label: '分类',
				prop: 'insuranceType',
				fixed: 'left',
			},
		],
	}
	let insureTypes = store.state.user.insureTypes || []
	if (insureTypes.length > 0) {
		//排序
		insureTypes = insureTypes.sort((a, b) => {
			return a.type - b.type
		})
		for (let {abbreviation, type} of insureTypes) {
			tempData.column.push({
				label: `${abbreviation}(元)`,
				prop: `p${type}`,
				formatter: (itemData) => {
					let pData = itemData[`p${type}`] || 0
					return pData === 0 ? '--' : (pData / 100).toFixed(2)
				},
			})
		}
	}
	return tempData
}

//结算信息维护

//结算设置
export const settleSettingOption = {
	card: true,
	labelWidth: 120,
	submitBtn: false,
	emptyBtn: false,
	gutter: 20,
	column: [
		{
			label: '自动结算',
			prop: 'autoSettle',
			type: 'switch',
			value: 0,
			disabled: false,
			change: ({value, column}) => {},
			focus: ({value, column}) => {},
			click: ({value, column}) => {},
			dicData: [
				{
					label: '关闭',
					value: '0',
				},
				{
					label: '开启',
					value: '1',
				},
			],
		},
		{
			label: '结算周期',
			prop: 'settlePeriod',
			type: 'switch',
			display: false,
			disabled: false,
			dicData: [
				{
					label: '月结',
					value: 'MONTH',
				},
				{
					label: '半月结',
					value: 'SEMI_MONTH',
				},
			],
			click: ({value, column}) => {},
		},
	],
}

//未结算保单列表
export const settleInfoPrivateOption = {
	card: true,
	stripe: true,
	border: true,
	align: 'center',
	addBtn: false,
	excelBtn: true,
	labelWidth: 130,
	gutter: 20,
	submitBtn: false,
	emptyBtn: false,
	column: [
		{
			label: '结算姓名',
			prop: 'userName',
			disabled: false,
			rules: [
				{
					required: true,
					message: '请输入 结算姓名',
					trigger: 'blur',
				},
			],
		},
		{
			label: '身份证号',
			prop: 'idNo',
			disabled: false,
			display: true,
			rules: [
				{
					required: true,
					message: '请输入 身份证号',
					trigger: 'blur',
				},
				{
					validator: rule.validatorIdNo,
					trigger: 'blur',
				},
				{
					validator: rule.validatorIdNoOld,
					trigger: 'blur',
				},
			],
		},
		{
			label: '手机号',
			prop: 'mobile',
			disabled: true,
			disabled: false,
			rules: [
				{
					required: true,
					message: '请输入 手机号',
					trigger: 'blur',
				},
			],
		},
		{
			label: '开户行',
			prop: 'bankName',
			disabled: false,
			rules: [
				{
					required: true,
					message: '请输入 开户行',
					trigger: 'blur',
				},
				{
					validator: rule.validatorChinese,
					message: '只能输入中文',
					trigger: 'blur',
				},
				{
					validator: (rule, value = '', callback) => {
						!value || value.includes('银行') ? callback() : callback(new Error(`开户行必须含有'银行'两个字`))
					},
					trigger: 'blur',
				},
			],
		},
		{
			label: '银行卡号',
			prop: 'cardNo',
			disabled: false,
			span: 12,
			rules: [
				{
					required: true,
					message: '请输入 银行卡号',
					trigger: 'blur',
				},
				{
					validator: rule.validatorNumber,
					message: '请输入 正确的银行卡号',
					trigger: 'blur',
				},
			],
		},
		{
			label: '开户地',
			type: 'cascader',
			prop: 'bankCity',
			emitPath: false,
			disabled: false,
			props: {
				label: 'areaName',
				value: 'areaCode',
			},
			dicUrl: `/dist/area/list/2`,
			filterable: true,
			showAllLevels: true,
			rules: [
				{
					required: true,
					message: '请选择 开户地',
					trigger: 'blur',
				},
			],
		},
		{
			label: '身份证正面',
			prop: 'cardFrontUrl',
			display: true,
			type: 'upload',
			disabled: false,
			dataType: 'string',
			listType: 'picture-img',
			action: '/dist/upload/idCard/front',
			limit: 1,
			tip: '请上传大小不超过2Mb的jpg/png文件',
			propsHttp: {
				res: 'data',
				url: 'cardImageUrl',
			},
			dragFile: true,
			rules: [
				{
					required: true,
					message: '请上传身份证正面',
					trigger: 'blur',
				},
			],
		},
		{
			label: '身份证反面',
			prop: 'cardBackUrl',
			display: true,
			type: 'upload',
			disabled: false,
			dataType: 'string',
			listType: 'picture-img',
			action: '/dist/upload/idCard/back',
			limit: 1,
			tip: '请上传大小不超过2Mb的jpg/png文件',
			propsHttp: {
				res: 'data',
				url: 'cardImageUrl',
			},
			dragFile: true,
			rules: [
				{
					required: true,
					message: '请上传身份证反面',
					trigger: 'blur',
				},
			],
		},
		{
			prop: 'del',
			disabled: true,
			formslot: true,
		},
	],
}

//未结算保单列表
export const settleInfoPublicOption = {
	card: true,
	stripe: true,
	border: true,
	align: 'center',
	addBtn: false,
	excelBtn: true,
	labelWidth: 130,
	gutter: 20,
	submitBtn: false,
	emptyBtn: false,
	column: [
		{
			label: '结算姓名',
			prop: 'userName',
			disabled: false,
			rules: [
				{
					required: true,
					message: '请输入 结算姓名',
					trigger: 'blur',
				},
			],
		},
		{
			label: '开户行',
			prop: 'bankName',
			disabled: false,
			rules: [
				{
					required: true,
					message: '请输入 开户行',
					trigger: 'blur',
				},
				{
					validator: rule.validatorChinese,
					message: '只能输入中文',
					trigger: 'blur',
				},
				{
					validator: (rule, value = '', callback) => {
						!value || value.includes('银行') ? callback() : callback(new Error(`开户行必须含有'银行'两个字`))
					},
					trigger: 'blur',
				},
			],
		},
		{
			label: '银行卡号',
			prop: 'cardNo',
			disabled: false,
			span: 12,
			row: true,
			rules: [
				{
					required: true,
					message: '请输入 银行卡号',
					trigger: 'blur',
				},
				{
					required: true,
					validator: rule.validatorNumber,
				},
			],
		},
		{
			label: '是否发邮件',
			prop: 'emailFlag',
			disabled: false,
			type: 'radio',
			row: false,
			dicData: [
				{
					label: '是',
					value: '1',
				},
				{
					label: '否',
					value: '0',
				},
			],
			rules: [
				{
					required: true,
					message: '请选择是否发邮件',
					trigger: 'blur',
				},
			],
			control: (value, form) => {
				return {
					email: {
						display: value === '1',
					},
					emailFlag: {
						row: value !== '1',
					},
				}
			},
		},
		{
			label: '邮箱',
			prop: 'email',
			disabled: false,
			display: false,
			rules: [
				{
					required: true,
					message: '请输入邮箱',
					trigger: 'blur',
				},
			],
		},
		{
			label: '',
			prop: 'del',
			formslot: true,
		},
	],
}

//奖励结算 未结算，结算中，已结算
export const awardApplyOption = (safe) => {
	return {
		card: true,
		stripe: true,
		border: true,
		align: 'center',
		menu: false,
		addBtn: false,
		excelBtn: true,
		searchLabelWidth: 140,
		column: [
			{
				label: '奖励ID',
				prop: 'id',
				hide: true,
			},
			{
				label: '奖励名称',
				prop: 'ruleId',
				type: 'select',
				width: 150,
				fixed: true,
				search: true,
				searchOrder: 1,
				formatter: ({ruleAward = null, coupon = null}) => {
					return ruleAward ? ruleAward.name : coupon ? coupon.name : '--'
				},
				searchFilterable: true,
				props: {
					label: 'name',
					value: 'id',
				},
				// dicUrl: '/dist/settle/ruleAward/page?pageNo=1&pageSize=100&current=1&size=100'
				dicData: [],
			},
			{
				label: '险种名称',
				prop: 'insureTypes',
				dicData: getInsureTypesString(),
				type: 'select',
				search: true,
				width: 150,
				searchOrder: 2,
			},
			{
				label: '奖励类型',
				prop: 'ruleType',
				dicData: [
					{
						label: '佣金券',
						value: 'COUPON',
					},
					{
						label: '返现',
						value: 'AWARD',
					},
				],
				type: 'select',
				search: true,
				width: 150,
				searchOrder: 2,
			},
			{
				label: '计算方式',
				prop: 'calculateMethod',
				dicData: [
					{
						label: '发放',
						value: 'SETTLE',
					},
					{
						label: '追回',
						value: 'RECOVERY',
					},
				],
				type: 'select',
				search: true,
				width: 150,
				searchOrder: 2,
			},
			{
				label: '达标档次',
				prop: 'feeRatePercent',
				formatter: ({ruleAward = {}, insureType = 0}) => {
					let {feeRatePercent = 0} = ruleAward
					return getHasFeeRateBySettleByRate(feeRatePercent, insureType)
				},
			},
			{
				label: '奖励档次',
				prop: 'countRatePercent',
				formatter: ({ruleAward = {}, insureType = 0}) => {
					let {countRatePercent = 0} = ruleAward
					return getHasFeeRateBySettleByRate(countRatePercent, insureType)
				},
			},
			{
				label: '主渠道名称',
				prop: 'channelId',
				search: true,
				type: 'select',
				hide: true,
				props: {
					label: 'name',
					value: 'id',
				},
				searchOrder: 1,
				searchFilterable: true,
				dicUrl: '/dist/distChannel/list?parentId=0',
			},
			{
				label: '主渠道名称',
				prop: 'mainChannelName',
				width: 110,
			},
			{
				label: '渠道名称',
				prop: 'channelName',
				width: 110,
			},
			{
				label: '保费金额(元)',
				width: 110,
				prop: 'payMoney',
			},
			{
				label: '奖励费用率',
				width: 110,
				prop: 'feeRate',
			},
			{
				label: '预计结算费用(元)',
				prop: 'feePre',
			},
			{
				label: '奖励是否兼得',
				prop: 'awardCombine',
				formatter: ({awardCombine = '--'}) => awardCombine,
			},
			{
				label: '统计类型',
				prop: 'countType',
				formatter: ({countType = '--'}) => countType,
			},
			{
				label: '开始时间',
				prop: 'settleStartTime',
				width: 140,
			},
			{
				label: '创建时间',
				prop: 'createdAt',
				search: true,
				type: 'datetime',
				searchRange: true,
				searchSpan: 12,
				format: 'yyyy-MM-dd HH:mm:ss',
				valueFormat: 'yyyy-MM-dd HH:mm:ss',
				width: 140,
			},
			{
				label: '生效时间',
				prop: 'countStartTime',
				width: 140,
			},
			{
				label: '到期时间',
				prop: 'countEndTime',
				width: 140,
			},
		],
	}
}

//未结算保单列表
export const zhuanpiaoOption = {
	card: true,
	stripe: true,
	border: true,
	align: 'center',
	addBtn: false,
	excelBtn: true,
	labelWidth: 120,
	gutter: 20,
	submitBtn: false,
	emptyBtn: false,
	column: [
		{
			label: '收件人姓名',
			prop: 'name',
			disabled: false,
			rules: [
				{
					required: true,
					message: '请输入 收件人姓名',
					trigger: 'blur',
				},
			],
		},
		{
			label: '收件人手机号',
			prop: 'phoneNo',
			rules: [
				{
					required: true,
					message: '请输入 收件人手机号',
					trigger: 'blur',
				},
				{
					validator: rule.validatorMobile,
					trigger: 'blur',
				},
			],
			disabled: false,
		},
		{
			label: '所在地区',
			type: 'cascader',
			prop: 'areaCodes123',
			props: {
				label: 'areaName',
				value: 'areaCode',
			},
			dicUrl: `/dist/area/list/3`,
			dicMethod: 'get',
			filterable: true,
			showAllLevels: true,
			display: true,
			rules: [
				{
					required: true,
					message: '请选择 所在地区',
					trigger: 'change',
				},
			],
			disabled: false,
		},
		{
			label: '详细地址',
			prop: 'address',
			rules: [
				{
					required: true,
					message: '请输入 详细地址',
					trigger: 'blur',
				},
			],
			disabled: false,
		},
	],
}
